import React, { ReactElement } from 'react';
import Tooltip from '../tooltip/tooltip.component';
import HintIcon from '../../icons/hint-icon';
import useStylesHint from './hint.styles';

const Hint: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    title,
    iconComponent,
  } = props;

  const { classes } = useStylesHint();

  const IconComponent: ReactComponent = iconComponent || HintIcon;

  return (
    <Tooltip withRightPlacement title={title}>
      <IconComponent className={classes.hintIcon} />
    </Tooltip>
  );
});

export default Hint;
